import { useState } from "react";

/**
 * Holds an emailed one-time token in memory for as long as the screen lives, so the address bar
 * can be cleaned while the person finishes. The token is a password: it is never written to
 * storage and never logged. If a different link opens in the same tab, the new one replaces the
 * held one.
 *
 * Reloading after the address bar was cleaned loses the token: the page then shows its
 * "no usable link" state, and the person opens the email link again (inspecting a link does not
 * use it up).
 *
 * Used by every screen an emailed link lands on: account setup, password reset, security alert.
 */
export function useCapturedToken(fromUrl: string | undefined): string {
  const [captured, setCaptured] = useState(fromUrl ?? "");
  // Adjusting state while rendering (React's documented pattern for "a prop changed"): no effect
  // and no extra render pass with a stale token.
  if (fromUrl && fromUrl !== captured) setCaptured(fromUrl);
  return captured;
}
